import {
    CREATE_SALES_DEMO_CUST_OR_PRACT_REQUEST,
    CREATE_SALES_DEMO_CUST_OR_PRACT_SUCCESS,
    CREATE_SALES_DEMO_CUST_OR_PRACT_FAILURE,
    CLEAR_CREATE_SALES_DEMO_CUST_OR_PRACT,
} from '../../../../Constants/actionTypes';



const initialState = {
    loading: false,
    session: null,
    error: null,
};

const demoSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_SALES_DEMO_CUST_OR_PRACT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case CREATE_SALES_DEMO_CUST_OR_PRACT_SUCCESS:
            return {
                ...state,
                loading: false,
                session: action.payload,
            };
        case CREATE_SALES_DEMO_CUST_OR_PRACT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CLEAR_CREATE_SALES_DEMO_CUST_OR_PRACT:
            return {
                ...initialState, // Reset to initial state
            };
        default:
            return state;
    }
};

export default demoSessionReducer;